import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
/* @vite-ignore */
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ButtonComponent, LoaderModule } from '@mds/ui';
import { EpdV2Service } from '../../services/epd-v2.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-epd-pep-preview',
  standalone: true,
  imports: [LoaderModule, PdfViewerModule, MatButtonModule, ButtonComponent],
  providers: [EpdV2Service],
  templateUrl: './epd-pep-preview.component.html',
  styleUrls: ['./epd-pep-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdPepPreviewComponent implements OnInit, OnDestroy {
  @ViewChild('epdV2Container') epdV2Container!: ElementRef;
  protected cdr = inject(ChangeDetectorRef);
  protected data = inject(MAT_DIALOG_DATA);
  protected epdV2Service = inject(EpdV2Service);

  pdfUrl: string | null = null;
  pdfref: string;

  ngOnInit(): void {
    const { url } = this.data;

    setTimeout(() => {
      this.epdV2Service.downloadAdditionalExports(url).subscribe((response: HttpResponse<Blob>) => {
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);
          if (match && match[1]) {
            this.pdfref = decodeURIComponent(match[1].replace(/['"]/g, '').trim());
          }
        }

        this.pdfUrl = URL.createObjectURL(response.body);

        this.epdV2Container?.nativeElement?.remove();
        this.cdr.markForCheck();
      });
    }, 100);
  }

  ngOnDestroy() {
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
  }

  export() {
    if (!this.pdfUrl) return;

    const anchor = document.createElement('a');
    anchor.href = this.pdfUrl;
    anchor.setAttribute('download', this.pdfref || '');
    anchor.click();
    setTimeout(() => {
      anchor.remove();
      URL.revokeObjectURL(this.pdfUrl);
    }, 100);
  }
}
